import * as angular from 'angular';

import { IGroupTrendService } from './groupTrend.service';
import { IExportToCsvService, IDateRangeService } from '../../../services';
import { refreshClick } from '../../../common';
import { ComponentDefinition, Dictionary, IValueViewModel, RefreshClickData } from '../../../models';

class GroupTrendController implements angular.IComponentController {
    isDataLoading: boolean;
    message: string;
    trend: any;
    groupGuid: string;

    readonly viewModels: Dictionary<IValueViewModel>;

    static $inject = ['$scope', 'groupTrendService', 'exportToCsvService', 'dateRangeService'];

    constructor(
        private _$scope: angular.IScope,
        private _groupTrendService: IGroupTrendService,
        private _exportToCsvService: IExportToCsvService,
        private _dateRangeService: IDateRangeService
    ) {
    }

    $onInit() {
        this._$scope.$on(refreshClick, (_event, data: RefreshClickData) => {
            if (this.trend) {
                this.isDataLoading = true;
                this.message = 'Loading data';
                this.loadStates(data, !!data.force)
                    .finally(() => this.isDataLoading = false);
            }
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['groupGuid'] && changesObj['groupGuid'].currentValue) {
            this.isDataLoading = true;
            this.message = 'Loading configuration';
            this._groupTrendService.load(changesObj['groupGuid'].currentValue)
                .then(data => {
                    this.trend = data;
                    return this.loadStates();
                })
                .catch(e => console.error(e))
                .finally(() => this.isDataLoading = false);
        }
    }

    exportToCsv(): void {
        try {
            this.isDataLoading = true;
            this.message = 'Exporting data to CSV';
            this.trend.exportToCsv()
                .finally(() => {
                    this.isDataLoading = false;
                });
        } catch (e) {
            this.isDataLoading = false;
        }
    }

    exportStates(): void {
        this.isDataLoading = true;
        this.message = 'Exporting states to CSV';
        this._exportToCsvService
            .getCsvGroupStates(this.groupGuid, this._dateRangeService.beginDate() as string, this._dateRangeService.endDate() as string)
            .finally(() => {
                this.isDataLoading = false;

            });
    }


    private loadStates(data?: any, force: boolean = false) {
        this.message = 'Loading data';
        return this._groupTrendService.loadStates(this.groupGuid, data, force)
            .then(respone => {
                this.trend.configuration.options.panes[2].areas = respone.calculated;
                this.trend.configuration.options.panes[1].areas = respone.reference;
            });
    }
}

export const wtGroupTrend: ComponentDefinition = {
    componentId: 'wtGroupTrend',
    controller: GroupTrendController,
    template: require('./groupTrend.component.html'),
    controllerAs: 'vm',
    bindings: {
        groupGuid: '<',
        viewModels: '<'
    }
};